import { SYS_BREAKPOINT_MD } from '@oneaudi/unified-web-alpha-common';
import styled from 'styled-components';
export const StyledHeader = styled.div `
  width: 100%;
  position: relative;

  [role='tablist'] {
    ${({ hideTabs }) => hideTabs && 'pointer-events: none;'}
  }

  .toggle-switch-container {
    height: 56px;
    display: flex;
    align-items: center;
    position: absolute;
    top: 0;
    right: 10px;
    z-index: 1;
  }

  .tabs {
    width: 100%;
    div[role='tabpanel'] {
      padding: 0;
    }

    td {
      border-top: none !important;
      padding: 0;
      vertical-align: bottom;
      width: 50%;
      word-break: break-word;
    }
  }

  @media screen and (max-width: ${SYS_BREAKPOINT_MD}) {
    flex-direction: column;
    align-items: flex-end;

    .tabs {
      padding-top: 48px;
    }

    .toggle-switch-container {
      height: 48px;
    }
  }
`;
